<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="41"
		height="40"
		viewBox="0 0 41 40"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M19.8744 11.6373C20.4846 11.0271 21.4739 11.0271 22.0841 11.6373L34.5841 24.1373C35.1943 24.7475 35.1943 25.7368 34.5841 26.347C33.9739 26.9572 32.9846 26.9572 32.3744 26.347L20.9792 14.9519L9.5841 26.347C8.97391 26.9572 7.98459 26.9572 7.37439 26.347C6.7642 25.7368 6.7642 24.7475 7.37439 24.1373L19.8744 11.6373Z"
			fill="#000"
		/>
	</svg>
</template>
